module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.footer) ? _c('footer', {
    staticClass: "c-footer"
  }, [_c('vue-cookie-accept-decline', {
    ref: 'cookiePanel',
    attrs: {
      "elementId": 'cookiePanel',
      "debug": false,
      "position": 'bottom-left',
      "type": 'floating',
      "disableDecline": true,
      "transitionName": 'slideFromBottom',
      "showPostponeButton": false
    },
    on: {
      "status": _vm.cookieStatus,
      "clicked-accept": _vm.cookieClickedAccept,
      "clicked-decline": _vm.cookieClickedDecline
    }
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.cookieMessage)
    },
    slot: "message"
  }), _vm._v(" "), _c('div', {
    slot: "acceptContent"
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm.cookieButtonYes) + "\n\t\t")])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('h4', {
    on: {
      "click": function($event) {
        _vm.scrollToTop(300)
      }
    }
  }, [_vm._v(_vm._s(_vm.footer.title))]), _vm._v(" "), _c('div', {
    staticClass: "c-footer__content",
    domProps: {
      "innerHTML": _vm._s(_vm.footer.content)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "c-footer__icons"
  }, _vm._l((_vm.footer.icons), function(icon) {
    return _c('a', {
      staticClass: "c-footer__icon",
      class: 'c-footer__icon--' + icon.type.toLowerCase(),
      attrs: {
        "href": icon.link,
        "target": "_blank",
        "rel": "noopener"
      }
    }, [_c('span', {
      staticClass: "visuallyhidden"
    }, [_vm._v(_vm._s(icon.type))])])
  }))])], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-footer__branding"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/glasses.svg",
      "alt": "Bandara"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-33d722cc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footer.vue
// module id = 260
// module chunks = 0